// Azure AD Group IDs for application access control
export const APP_GROUPS = {
  // Training - visible to all RR employees
  TRAINING: 'db3ea67a-1277-4daf-a184-b4d71ae240c5',
  
  // bumbl.b (AI - Invoice Application) - ~20-30 members
  BUMBLB: '4b14ed01-6dc6-408d-90f1-f66d0ab8bdb3',
  
  // Space Available (AI - Space Application) - ~20-30 members
  SPACE_AVAILABLE: 'c0bdcdfe-977b-41e6-ba4c-9e606c1453e7',
  
  // ResChat (AI - Residential Chat) - ~20-30 members
  RESCHAT: '490996bd-15d5-4f93-884c-268aa426d61f',
  
  // InsightManager (AI - Insight Manager) - ~20-30 members
  INSIGHT_MANAGER: 'cf77a6f5-6209-40e5-8e9d-a8063a9100ba',
  
  // LeaseChat (AI - Lease Application) - ~20-30 members
  LEASE_CHAT: '17846218-cb37-4989-b554-858c538dd7a5',
} as const;

export type AppName = keyof typeof APP_GROUPS;
